import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-board" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "board" }
const _hoisted_4 = { class: "board-class blue" }
const _hoisted_5 = { class: "board-col" }
const _hoisted_6 = { class: "board-col" }
const _hoisted_7 = { class: "board-class purple" }
const _hoisted_8 = { class: "board-col" }
const _hoisted_9 = { class: "board-col" }
const _hoisted_10 = { class: "board-class pink" }
const _hoisted_11 = { class: "board-col" }
const _hoisted_12 = { class: "board-col" }
const _hoisted_13 = { class: "board-class rose" }
const _hoisted_14 = { class: "section" }

import { ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import { getBoardList } from "@/api"
import { getTagColor } from "@/utils"
import { getRequestTypeValue, getPaymentTypeValue, getDocumentTypeValue }  from '@/utils/getValueForKey'
import BoardState from '@/components/BoardState.vue'
import BoardStateItem from '@/components/BoardStateItem.vue'
import StatusTag from "@/components/StatusTag.vue"
import CommonLoader from '@/components/CommonLoader.vue'
import CommonError from '@/components/CommonError.vue'
import { RequestActiveStatusKeys } from '@/types/constants'
import { RequestOnBoard, RequestNonIssue } from "@/types/Request"
import type { TableColumnCtx } from 'element-plus';

type Requests = {
  [key in RequestActiveStatusKeys]: RequestOnBoard[];
} & {
  NON_ISSUE: RequestNonIssue[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardPage',
  setup(__props) {

const requests = ref<Requests>({
  CREATED_REQUEST_PLAN: [],
  CREATED_REQUEST_PV: [],
  CREATED_REQUEST_JAM: [],
  CREATED_REQUEST_ADDITIONAL: [],
  DAY_PAYMENT_WIRE: [],
  DAY_PAYMENT_WIRE_DELAY: [],
  DAY_PAYMENT_CARD: [],
  DAY_INVOICE_TAX: [],
  DAY_INVOICE: [],
  NEED_TO_EXTEND: [],
  NON_ISSUE: []
});
const loading = ref<boolean>(false);
const isError = ref<boolean>(false);

const fetchData = async () => {
  loading.value = true;

  try {
    const response = await getBoardList();
    // console.log('Board Response', response.result);
    if(response.success) {
      const result: Requests = response.result;
      const filteredResult = {
        CREATED_REQUEST_PLAN: result.CREATED_REQUEST_PLAN,
        CREATED_REQUEST_PV: result.CREATED_REQUEST_PV,
        CREATED_REQUEST_JAM: result.CREATED_REQUEST_JAM,
        CREATED_REQUEST_ADDITIONAL: result.CREATED_REQUEST_ADDITIONAL,
        DAY_PAYMENT_WIRE: result.DAY_PAYMENT_WIRE,
        DAY_PAYMENT_WIRE_DELAY: result.DAY_PAYMENT_WIRE_DELAY,
        DAY_PAYMENT_CARD: result.DAY_PAYMENT_CARD,
        DAY_INVOICE_TAX: result.DAY_INVOICE_TAX,
        DAY_INVOICE: result.DAY_INVOICE,
        NEED_TO_EXTEND: result.NEED_TO_EXTEND,
        NON_ISSUE: result.NON_ISSUE,
      }
      requests.value = filteredResult;
    }
  } catch (error) {
    loading.value = false;
    isError.value = true;
    console.error('Error Message:', error);
  } finally {
    loading.value = false;
  }
}

// onMounted(fetchData);
fetchData();

const router = useRouter();
const toRequestView = (id: string, stat: string) => router.push({
  name: 'ViewStat',
  params: { id, stat }
});

const filterHandler = (
  value: string,
  row: RequestNonIssue,
  column: TableColumnCtx<RequestNonIssue>
) => {
  const property = column['property'] as keyof RequestNonIssue;
  return row[property] === value;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value && !isError.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("section", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "tit-h3" }, " 처리 필요 ", -1)),
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "board-tit" }, " 생성 ", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(BoardState, {
                    title: "플랜 생성 대기",
                    count: requests.value['CREATED_REQUEST_PLAN']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.CREATED_REQUEST_PLAN, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "CREATED_REQUEST_PLAN",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(BoardState, {
                    title: "PV 충전 대기",
                    count: requests.value['CREATED_REQUEST_PV']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.CREATED_REQUEST_PV, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "CREATED_REQUEST_PV",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"]),
                  _createVNode(BoardState, {
                    title: "JAM 충전 대기",
                    count: requests.value['CREATED_REQUEST_JAM']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.CREATED_REQUEST_JAM, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "CREATED_REQUEST_JAM",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"]),
                  _createVNode(BoardState, {
                    title: "부가 서비스 처리 대기",
                    count: requests.value['CREATED_REQUEST_ADDITIONAL']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.CREATED_REQUEST_ADDITIONAL, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "CREATED_REQUEST_ADDITIONAL",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"])
                ])
              ]),
              _createElementVNode("li", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "board-tit" }, " 결제 ", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(BoardState, {
                    title: "무통장 입금 대기",
                    count: requests.value['DAY_PAYMENT_WIRE']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.DAY_PAYMENT_WIRE, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "DAY_PAYMENT_WIRE",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"]),
                  _createVNode(BoardState, {
                    title: "무통장 입금 지연",
                    count: requests.value['DAY_PAYMENT_WIRE_DELAY']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.DAY_PAYMENT_WIRE_DELAY, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "DAY_PAYMENT_WIRE_DELAY",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(BoardState, {
                    title: "카드 결제 대기",
                    count: requests.value['DAY_PAYMENT_CARD']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.DAY_PAYMENT_CARD, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "DAY_PAYMENT_CARD",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"])
                ])
              ]),
              _createElementVNode("li", _hoisted_10, [
                _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "board-tit" }, " 서류 발행 ", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(BoardState, {
                    title: "세금 계산서",
                    count: requests.value['DAY_INVOICE_TAX']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.DAY_INVOICE_TAX, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "DAY_INVOICE_TAX",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(BoardState, {
                    title: "기타 서류",
                    count: requests.value['DAY_INVOICE']?.length || 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.DAY_INVOICE, (request, index) => {
                        return (_openBlock(), _createBlock(BoardStateItem, {
                          key: index,
                          status: "DAY_INVOICE",
                          data: request
                        }, null, 8, ["data"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"])
                ])
              ]),
              _createElementVNode("li", _hoisted_13, [
                _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "board-tit" }, " 연장 ", -1)),
                _createVNode(BoardState, {
                  title: "플랜 연장 필요",
                  count: requests.value['NEED_TO_EXTEND']?.length || 0
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value.NEED_TO_EXTEND, (request, index) => {
                      return (_openBlock(), _createBlock(BoardStateItem, {
                        key: index,
                        status: "NEED_TO_EXTEND",
                        data: request
                      }, null, 8, ["data"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["count"])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_14, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "tit-h3" }, " 이슈 없음 ", -1)),
            _createVNode(_component_el_table, {
              data: requests.value.NON_ISSUE,
              "default-sort": { prop: 'useStartDate', order: 'ascending' },
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "자세히",
                  width: "60"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      "aria-label": "자세히",
                      onClick: ($event: any) => (toRequestView(scope.row._id, 'NON_ISSUE'))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-file-lines" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "companyName",
                  label: "회사명 / 계정",
                  width: "220",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.companyName), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(scope.row.userId), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "requestType",
                  label: "요청 유형",
                  width: "100",
                  align: "center",
                  filters: [
              { text: '플랜', value: 'PLAN' },
              { text: 'PV 충전', value: 'PV_CHARGE' },
              { text: 'Jam 충전', value: 'JAM_CHARGE' },
              { text: '부가 서비스', value: 'ADDITIONAL' }
            ],
                  "filter-method": filterHandler
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(StatusTag, {
                      color: _unref(getTagColor)(scope.row.requestType),
                      size: "small",
                      text: _unref(getRequestTypeValue)(scope.row.requestType)
                    }, null, 8, ["color", "text"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "useStartDate",
                  label: "사용 시작일",
                  width: "110",
                  align: "center",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "useEndDate",
                  label: "사용 종료일",
                  width: "110",
                  align: "center",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.useEndDate)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(scope.row.useEndDate), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "period",
                  label: "사용 기간",
                  width: "100",
                  align: "center",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.period)
                      ? (_openBlock(), _createBlock(StatusTag, {
                          key: 0,
                          color: "gray",
                          size: "small",
                          text: `${scope.row.period}개월`
                        }, null, 8, ["text"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "paymentType",
                  label: "결제 방식",
                  width: "100",
                  align: "center",
                  filters: [
              { text: '무통장', value: 'wire' },
              { text: '카드', value: 'card' },
              { text: '무상', value: 'free' }
            ],
                  "filter-method": filterHandler
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(StatusTag, {
                      color: _unref(getTagColor)(scope.row.paymentType),
                      size: "small",
                      text: _unref(getPaymentTypeValue)(scope.row.paymentType)
                    }, null, 8, ["color", "text"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "paymentDate",
                  label: "최초 결제일",
                  width: "110",
                  align: "center",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "발행 서류",
                  width: "120",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.docList.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(scope.row.docList, (doc, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: "center"
                          }, _toDisplayString(_unref(getDocumentTypeValue)(doc)), 1))
                        }), 128))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "firstDocDate",
                  label: "최초 서류 발행일",
                  width: "120",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.firstDocDate)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(scope.row.firstDocDate), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "memo",
                  label: "메모"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.memo)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(scope.row.memo), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ])
        ], 64))
      : (loading.value)
        ? (_openBlock(), _createBlock(CommonLoader, { key: 1 }))
        : (isError.value && !loading.value)
          ? (_openBlock(), _createBlock(CommonError, {
              key: 2,
              message: "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요."
            }))
          : _createCommentVNode("", true)
  ]))
}
}

})